import * as Yup from 'yup'

const facephotoFormSchema = Yup.object({
  facephoto: Yup.mixed().required('Debes incluir una foto tuya'),
})

export default facephotoFormSchema
